module.exports = require("./ar-SS");